<template>
    <div class="world">
        <div class="world__top world-full-width">
          <div class="world__photos">
              <VerticalPhotoCarousel :folders="filepacks" ref="photos"/>
          </div>
          <div class="world__info">
            <WorldLocationInfo :active-folder="filepacks[activeCityIndex]" />
          </div>
          <div class="world__globe">
            <World ref="world" :cities="filepacks"/> 
          </div>
        </div>
        <div class="world__bottom">
          <FolderScroller :folders="filepacks" @folder-selected="selectCity" />
        </div>
  </div>
</template>

<script>
import World from "./World.vue"
import FolderScroller from "./FolderScroller.vue"
import VerticalPhotoCarousel from "./VerticalPhotoCarousel.vue"
// import HorizontalPhotoCarousel from "./HorizontalPhotoCarousel.vue";
import WorldLocationInfo from "./WorldLocationInfo.vue";

export default {
  name: "WorldSection",
  components: {
    World,
    FolderScroller,
    VerticalPhotoCarousel,
    WorldLocationInfo
    // HorizontalPhotoCarousel
  },
  data() {
    return {
      defaultMovementInterval: null,
      userInterventionTimeout: null,
      activeCityIndex: 0,
      filepacks: [
      { 
          name: "raprave-1", 
          title: "Raprave Season Zero",
          city: "Brooklyn, NY", 
          lat: 40.7128, lon: -74.0060, 
          color: 0xff0000, 
          image: "/figures/atm/raprave-1.png",
          description: "First distribution of files with the ATM inside a Night Club.",
          mobileDescription: "Distributed Raprave at a night club.",
          year: "2023"
        },
        { 
          name: "entropy",
          title: "Entropy Paris Fashion Week",
          city: "Paris, FR", 
          lat: 48.8566, 
          lon: 2.3522, 
          color: 0x00ff00,
          image: "/figures/atm/entropy.png",
          description: "Curated files during Paris Fashion week from Entropy community.",
          mobileDescription: "With Entropy for Paris Fashion week.",
          year: "2023"
        },
        { 
          name: "soldout", 
          title: "SOLD OUT",
          city: "Tokyo, JP", 
          lat: 35.6895, 
          lon: 139.6917, 
          color: 0x0000ff, 
          image: "/figures/atm/soldout.png",
          description: "Pop-up for a new streetwear brand WIP in Shibuya.",
          mobileDescription: "SOLDOUT Pop-up streetwear brand.",
          year: "2023"
        },
        { 
          name: "fwb-fest", 
          title: "FWB Fest",
          city: "Idyllwild, CA", 
          lat: 33.9382, 
          lon: -116.9153, 
          color: 0x0000ff, 
          image: "/figures/atm/fwb-fest.png",
          description: "Distributed Artist files on Day 1, Attendee expansion pack on Day 2.",
          mobileDescription: "FWB Fest with artists and attendees.",
          year: "2023"
        },
        { 
          name: "pinkessay", 
          title: "Pink Essay",
          city: "New York, NY", 
          lat: 40.7128, 
          lon: -74.0060, 
          color: 0x0000ff, 
          image: "/figures/atm/pinkessay.png",
          description: "Premiere for Designheads at a digital zine launch event.",
          mobileDescription: "Digital zine launch event.",
          year: "2022"
        },
        { 
          name: "supercon", 
          title: "Supercon",
          city: "Pasadena, CA", 
          lat: 34.1347, 
          lon: -118.1526, 
          color: 0x0000ff, 
          image: "/figures/atm/supercon.png",
          description: "Made the ATM portable and brought it to a hacker conference.",
          mobileDescription: "Portable ATM at a hacker conference.",
          year: "2023"
        },
        { 
          name: "temperance", 
          title: "Temperance Alley Garden",
          city: "Washington, D.C.", 
          lat: 38.9072, 
          lon: -77.0369, 
          color: 0x0000ff, 
          image: "/figures/atm/temperance.png",
          description: "An ATM in a garden harvesting files for the local community.",
          mobileDescription: "Temperance Alley Garden file harvests.",
          year: "2023"
        },
        { 
          name: "urlan", 
          title: "urLAN Party",
          city: "Brooklyn, NY", 
          lat: 40.7128, 
          lon: -74.0060, 
          color: 0x0000ff, 
          image: "/figures/atm/urlan.png",
          description: "Gum.mp3 and MadeintheURL hosted a night club gaming party.",
          mobileDescription: "Gum.mp3 and MadeintheURL collab.",
          year: "2023"
        },
        { 
          name: "sf", 
          title: "SF Meetup",
          city: "San Fransisco, CA", 
          lat: 37.7749, 
          lon: -122.4194, 
          color: 0x0000ff, 
          image: "/figures/atm/sf-atm.png",
          description: "Turned a club bar into a genuis bar, grab a drink and onboard.",
          mobileDescription: "Turned a club bar into a genuis bar.",
          year: "2023"
        },
      ],
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    selectCity(folderIndex) {
      clearInterval(this.defaultMovementInterval);
      clearTimeout(this.userInterventionTimeout);

      this.$refs.world.moveToCityByUser(folderIndex);
      this.$refs.photos.setActiveFolder(folderIndex);

      this.activeCityIndex = folderIndex;
    }
  },
};
</script>

<style scoped>

.world {
  background-color: var(--container-color);
  margin: 6.2rem 2.4rem;
  padding-top: 2.4rem;
}

.world__top {
  background: #393939;
  margin-top: 2.4rem;
  height: 60vh;
  display: flex;
  flex-direction: row;
  position: relative;
}

.world-full-width {
  width: calc(100% + 4.8rem);
  margin: 0 -2.4rem;
}

.world__photos {
  height: 100%;
  width: 50%;
  align-self: flex-start;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.world__globe {
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
}

.world__info {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 200;
  width: 332px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding: 0;
}

@supports not (backdrop-filter: blur(8px)) {
  /* Fallback for browsers that don't support backdrop-filter */
  .location-info__blur-backdrop {
    background: rgba(0, 0, 0, 0.7); /* More opaque background when blur isn't available */
  }
}



@media screen and (max-width: 775px) {

  .world__top {
    height: 32vh;
  }

  .world__photos {
    overflow: hidden;
    padding-left: 7%;
    display: block;
  }

  .world__info {
    width: 100%;
  }
}
</style>
